<template>
  <SingleEvent />
</template>

<script>
import SingleEvent from '@/components/content/events/EditSelectedEvent.vue'

export default {
  name: 'ContentEvent',
  components: { SingleEvent }
}
</script>

<style scoped>

</style>
